import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from './Button';
import { useTheme } from '../../context/ThemeContext';
export function ThemeToggle() {
  const {
    theme,
    setTheme
  } = useTheme();
  return <Button variant="ghost" size="icon" onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')} className="rounded-full w-9 h-9" data-id="element-244">
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" data-id="element-245" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" data-id="element-246" />
      <span className="sr-only" data-id="element-247">Alternar tema</span>
    </Button>;
}